import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT
var ossiroot = window.OSSI_Path


//获取列表数据
export const listData = (params) => {
  return axios.post(root + '/barcode/jxcgoodsbarcode/list', qs.stringify(params))
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/barcode/jxcgoodsbarcode/remove', qs.stringify(params))
}

//根据seedcode获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/barcode/jxcgoodsbarcode/edit', qs.stringify(params))
}
//根据packagesize和barcode获取某一行的明细数据
export const bardetail = (params) => {
  return axios.post(root + '/barcode/jxcgoodsbarcode/bardetail', qs.stringify(params))
}
export const goodsar = (params) => {
  return axios.post(ossiroot + '/barcode/jxcgoodsbarcode/bar4sell', qs.stringify(params))
}

//保存某一行的数据
export const saveBarCodeData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/barcode/jxcgoodsbarcode/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/barcode/jxcgoodsbarcode/save', qs.stringify(params))
  }
}

export const createGoodsbarcode = (params) => {
  return axios.post(root + '/barcode/jxcgoodsbarcode/createGoodsbarcode', qs.stringify(params))
}







// WEBPACK FOOTER //
// ./src/api/set/jxcgoodsbarcode.js